import { Component, Input, OnInit } from '@angular/core';
import { EnumTypeAlertRider, RiderAlertService } from '../../services/rider-alert.service';
import { Subscription } from 'rxjs/Subscription';
import { viewMessageAlertRider } from '../../../A2-utils/export-functions/functions-services';
import { T2LoadingService} from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-view-rider-alert',
  templateUrl: './view-rider-alert.component.html',
  styleUrls: ['./view-rider-alert.component.scss']
})
export class ViewRiderAlertComponent implements OnInit {

  @Input() riderId: number = undefined;
  @Input() riderName: string = undefined;
  @Input() typeAlert: number = undefined;
  @Input() hasAlerts: boolean = undefined;
  @Input() emAlert = 'em-2-0';
  @Input() viewMessageInitial: boolean = undefined;
  public viewAlert: boolean;
  private typeAlerRider = EnumTypeAlertRider;
  private subscrip: Subscription[] = [];
  constructor(
    private _riderAlertService: RiderAlertService,
    private loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
  ) { }

  ngOnInit() {
    this.verifyAlertRider(this.riderId);
  }

  public onOpenAlert(): void {
    this.getRiderAlerts(this.riderId, this.riderName);
  }

  /**
   * @description verifica si tiene alert y las llama
   */
  private getRiderAlerts(riderId: number, name?: string): void {
    this.loading.show();
    this.subscrip.push(this._riderAlertService.getAlertRiderByTypes(riderId, this.typeAlert).subscribe(
      (success: string[]) => {
        this.loading.hiden();
        if (success && success.length) {
          viewMessageAlertRider(success, name ? name : 'This Rider');
        } else {
          this.sweetAlertHelper.createCustomAlert({
            title: name ? name : '',
            text: 'This driver has not alert',
            type: 'warning',
          });
        }
      },
      error => {
        this.loading.hiden();
      }
    ));
  }
  private verifyAlertRider(riderid: number): void {
    this.subscrip.push(this._riderAlertService.getAlertRiderByTypes(riderid, this.typeAlert).subscribe(
      (success: string[]) => {
        if (success && success.length) {
          this.viewAlert = true;
          if (this.viewMessageInitial) {
            viewMessageAlertRider(success, 'This Rider');
          }
        } else {
          this.viewAlert = false;
        }
      }
    ));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/view-rider-alert/view-rider-alert.component.ts